module.exports = __webpack_public_path__ + "img/v4_h1.700a5872.png";